import bus from '@/utils/eventBus'

export default {
  data: function () {
    return {
      actions: false
    }
  },
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  methods: {
    getImages () {
      bus.$emit('to-show', {show: true})
    },
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    },
    getTenantUnits (unit) {
      const params = {
        unit_id: unit.unit_id,
        tower_id: unit.tower_id
      }
      this.$http.post('/v1/dweller/unit/tenant/search', params)
        .then(({data}) => {
          console.log(data)
          return data
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/unit/index/components/resources/index.js